import React, {Component, useEffect, useState} from 'react'

import CircularProgress from '@material-ui/core/CircularProgress';
import {useParams} from "react-router-dom";
import AutoclaveCicloSelecaoCiclo from "./AutoclaveCicloSelecaoCiclo";
import {makeStyles} from "@material-ui/styles";
import {useDispatch, useSelector} from "react-redux";
import {getAutoclaveHistoricoIndicadores} from "../../../actions/autoclaveActions";
import AutoclaveCicloDetalhes from "./AutoclaveCicloDetalhes";
import {Grid} from "@material-ui/core";

const useStyles = makeStyles(theme => ({
    dashboardCardSection: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1) * 8
    },
    newServiceOrderTooltip: {
        position: 'fixed',
        top: '90vh',
        right: '2vh',
    },
    leftMargin: {
        marginLeft: theme.spacing(1)
    },
    button: {
        margin: theme.spacing(1)
    },
    infoIcon: {
        verticalAlign: "middle"
    },
    progress: {
        margin: theme.spacing(1) * 2,
    },
    relative: {
        position: 'relative'
    },
    formControl: {
        marginRight: theme.spacing(1),
        minWidth: theme.spacing(1) * 10,
    },
    textCenter: {
        textAlign: 'center'
    },
    marginChart: {
        marginBottom: '20px'
    }
}));


const AutoclaveCicloMainView = (props) => {
    const classes = useStyles();
    const routeParams = useParams();

    const autoclaves = useSelector( state => state.autoclaves.Autoclaves );
    const isFetching = useSelector( state => state.autoclaves.isFetchingAutoclaveCicloIndicadores);


    const [autoclaveCodigo, setAutoclaveCodigo] = useState('');
    const [ciclo, setCiclo] = useState('');
    const [autoclaveId, setAutoclaveId]= useState(0);

    const [dadosVisiveis, setDadosVisiveis] = useState(false);

    const dispatch = useDispatch();


    useEffect(() => {

        if (routeParams.autoclave !== '' && routeParams.ciclo!== '') {
            setAutoclaveCodigo(routeParams.autoclave);
            setCiclo(routeParams.ciclo);
            setDadosVisiveis(true);

        }

    }, [routeParams]);




    useEffect(() => {
        console.log('UseEffect', autoclaveId, autoclaveCodigo, ciclo);
        const ac = autoclaves.find( i => i.codigo * 1 === autoclaveCodigo * 1);
        if (typeof(ac) !== "undefined" && ac !== null) {
            if (ac.id !== 0 && ciclo !== '') {
                setAutoclaveId(ac.id);
                console.log('getAutoclaveHistoricoIndicadores', ac.id, ciclo);
                dispatch(getAutoclaveHistoricoIndicadores(ac.id, ciclo));
                setDadosVisiveis(true);

            } else {

            }
        }
    }, [ciclo]);


    const novoCiclo = ( xa, xc) => {
        setDadosVisiveis(false);
        console.log('novoCiclo setautoclavecodigo', xa );
        setAutoclaveCodigo(xa);
        console.log('novoCiclo setciclo', xc );
        setCiclo(xc);
        console.log('novoCiclo fim');

    }



    const renderContent = () => {

        if (isFetching) {
            console.log("isFetchingisFetchingisFetchingisFetchingisFetching")
            return (
                <React.Fragment>
                    <Grid container item style={{display: 'flex', justifyContent: 'center'}}>

                        <CircularProgress className={classes.progress} color={'secondary'} size={'10rem'} />
                    </Grid>

                </React.Fragment>
            );
        }
        if (dadosVisiveis) {
            return (
                <React.Fragment>
                    <AutoclaveCicloDetalhes autoclaveId={autoclaveId} autoclaveCodigo={autoclaveCodigo} ciclo={ciclo}/>
                </React.Fragment>
            )
        }
        return (<React.Fragment/>);
    }

    return (
        <React.Fragment>
            <CircularProgress/>
            <AutoclaveCicloSelecaoCiclo autoclaveCodigo={autoclaveCodigo} ciclo={ciclo} onSubmit={novoCiclo}/>
            {renderContent()}
        </React.Fragment>
    );



};


export default (AutoclaveCicloMainView);




